import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import LandingNews from "./component";
import { fetchLandingNewsPageData, fetchABTestsConfigData } from "./initData";
import { getSelection } from "../../hooks/useABTest/utils";

const LandingNewsPOC = (props) => {
    const [clickGoal, setClickGoal] = useState(null);
    const abTestEnabled = useSelector((state) => {
        const pathsArray = state.featureflags?.lineupoptimization ?? [];
        return pathsArray.includes(props.match.url.toLocaleLowerCase());
    });
    const abortObject = useRef(null);
    const dispatch = useDispatch();

    const getVariantItem = (variants = {}, selection) => {
        if (!selection) return null;
        return variants[selection];
    };

    useEffect(() => {
        const nextParams = { contentId: "" };
        abortObject.current = false;
        fetchABTestsConfigData(props.match.params.region).then(
            async (testData) => {
                if (testData && abTestEnabled) {
                    const selection = await getSelection(testData.id);
                    if (selection) {
                        setClickGoal(testData.goals?.clicked);
                        const variant = getVariantItem(
                            testData.variants,
                            selection
                        );
                        const abTestSlug = variant?.content || null;
                        if (abTestSlug && /new-lineup$/.test(variant.label)) {
                            nextParams.abTestSlug = abTestSlug;
                            dispatch(
                                fetchLandingNewsPageData(
                                    props.match.url,
                                    nextParams
                                )
                            );
                            abortObject.current = true;
                        }
                    }
                }
            }
        );
    }, [props.match.url, abTestEnabled]);
    return <LandingNews {...props} abTestGoal={clickGoal} />;
};

export default LandingNewsPOC;
